import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom';
// import { useLocation } from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';
import 'rsuite/lib/styles/index.less'; // or 'rsuite/dist/styles/rsuite-default.css'
import LayoutMain from './layouts/Main';
import GeneralLayout from './layouts/Module/General/Main';
import './neoverv/scss/styles.scss';
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import 'react-toastify/dist/ReactToastify.css';
import ResetPassword from './views/pages/Module/General/forgotpassword/ResetPassword';
import Spinner from 'react-bootstrap/Spinner';
import ErrorMsg from '../src/views/elements/module/general/ErrorMsg/ErrorMsg';

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const store = createStore(reducers,composeEnhancers(applyMiddleware(thunk)));

// Routes import
import SignUp from './routes/SignUp';

// Themes import
import { theme, components, defaultProps } from "./theme";

// Mantine libs
import { MantineProvider } from "@mantine/core";
import { Notifications } from '@mantine/notifications';

import UtilityBillingTemplate from "./views/pages/Module/UtilityBilling/UtilityBillingTemplate";
import ErrorBoundary from './helpers/ErrorBoundaries';

export default function App() {
  // const location = useLocation();

  // React.useEffect(() => {
  //   console.log('Location changed');
  // }, [location]);

  // Detects a new frontend deploy (build/version.json is regenerated by
  // scripts/generate-version.js on every `npm run build`) and reloads the
  // page to pick it up. Baseline is kept in a ref, not state, so a failed
  // fetch can never permanently stop the interval from being set up.
  const deployedVersionRef = useRef(null);

  useEffect(() => {
    // if (process.env.NODE_ENV !== 'production') {
    //   return undefined;
    // }

    const fetchVersion = async () => {
      try {
        const response = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' });
        if (!response.ok) {
          return null;
        }
        const data = await response.json();
        return data.version;
      } catch (error) {
        return null;
      }
    };

    const checkForUpdates = async () => {
      const latestVersion = await fetchVersion();
      if (!latestVersion) {
        return;
      }

      if (deployedVersionRef.current === null) {
        deployedVersionRef.current = latestVersion;
        return;
      }

      if (deployedVersionRef.current !== latestVersion) {
        window.location.reload();
      }
    };

    checkForUpdates();
    const intervalId = setInterval(checkForUpdates, 60000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <MantineProvider theme={theme}>
      {/* Above every Modal's zIndex (the highest in use is 1000000, e.g.
      BuyPremiumModal/LegalConsentModal) so a notification triggered while one
      is open — a validation toast, an error — isn't hidden behind its overlay. */}
      <Notifications position="top-center" zIndex={2000000} autoClose={5000} />
      <ErrorBoundary>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ErrorMsg errorMsg={''} />
            {/* <div className="hh_loader" id="hello-housing-loader" style={{ display: 'block' }}>
              <div className="hh_loader_bg"></div>
              <Spinner animation="border" className="hh_loader_spinner" variant="primary" />
            </div> */}
            <BrowserRouter>
          
              <Switch>
                <Route path="/login" component={GeneralLayout} />
                <Route path="/signup" component={SignUp} />
                <Route path="/forgotpassword" component={GeneralLayout} />
                <Route path="/resetpassword" component={GeneralLayout} />
                <Route path="/" component={LayoutMain} />
              </Switch>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    </MantineProvider>
  );
}
